import axios from "axios";

export const createBalanceAccount = (body) => {
  return axios.post("/api/1.0/balance-accounts", body);
};

export const searchListBalanceAccounts = () => {
  return axios.get("/api/1.0/balance-accounts/list");
};
